export default __webpack_public_path__ + "static/media/logo1.40b41ca5.png";